import React from 'react';
import PropTypes from 'prop-types';
import { ContentSection } from '~components/Layout';
import StatePageAccordion, {
  AccordionGroup,
} from '~components/common/Accordion/StatePageAccordion';
import {
  whatAreTheSourcesForThisInformation,
  whereCanIFindVotingResources,
} from '~utils/faqAnswersContactsAndReferences';
import Markdown from '~components/common/Markdown';

export default function StateExternalLinks({ info, state }) {
  return (
    <ContentSection width='mid' isZebraStriped>
      <a id='external-resources' aria-hidden='true' />
      <h2 className='mt-0'>External resources</h2>

      <AccordionGroup>
        <StatePageAccordion
          heading={`Where can I find voting resources for ${state.name}?`}
        >
          <Markdown
            content={whereCanIFindVotingResources(info, state.name, state.code)}
          />
        </StatePageAccordion>
        <StatePageAccordion heading='What are the sources for information on this page?'>
          <Markdown
            content={whatAreTheSourcesForThisInformation(
              info,
              state.name,
              state.code
            )}
          />
        </StatePageAccordion>
      </AccordionGroup>
    </ContentSection>
  );
}

StateExternalLinks.propTypes = {
  state: PropTypes.object,
  info: PropTypes.object,
};
